import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export function shortAddress(addr: string, head = 6, tail = 4): string {
    if (!addr) return ''
    if (addr.length <= head + tail + 2) return addr
    return `${addr.slice(0, head)}…${addr.slice(-tail)}`
}

export function formatTimestamp(iso: string | Date | undefined | null): string {
    if (!iso) return '—'
    const d = typeof iso === 'string' ? new Date(iso) : iso
    if (Number.isNaN(d.getTime())) return '—'
    return d.toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    })
}

export function isHexAddress(value: string): value is `0x${string}` {
    return /^0x[a-fA-F0-9]{40}$/.test(value)
}
